import { NgModule } from '@angular/core';
import { PasswordComponent } from './password.component';

@NgModule({
  imports: [PasswordComponent],
  exports: [PasswordComponent]
})
export class PasswordModule {}
